import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-role-permision',
  templateUrl: './role-permision.component.html',
  styleUrls: ['./role-permision.component.css']
})
export class RolePermisionComponent implements OnInit {


  Submitted = false;
  ADMUserType = [];
  BranchRoleList = [];
  BranchRolePermissionList = [];

  constructor(private adminservice: AdminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  RolePermissionModel = {
    UserTypeID: 3,
    RoleID: 0,
  }

  GetBranchRolePermission() {
    this.spinnerService.show();
    this.adminservice.GetBranchRolePermission(this.RolePermissionModel.RoleID).subscribe((data: any) => {
      this.BranchRolePermissionList = data.BranchRolePermissionList;
      this.spinnerService.hide();
    });
  };

  SaveBranchRolePermission() {
    this.adminservice.SaveBranchRolePermission(this.RolePermissionModel.RoleID, JSON.stringify(this.BranchRolePermissionList)).subscribe((data: any) => {
      var result=JSON.parse(data)
      this.globalHelper.CheckActionStatus(result);
      
    });
  };


  ngOnInit() {
    this.GetAllBranchRole();
    this.GetAllUserType();
  }

  GetAllUserType() {
    this.lookupservice.GetLookupsList('ADMUserType', '').subscribe((data: any) => {
      this.ADMUserType = data.LookupItems;
    });
  };

  GetAllBranchRole() {
    this.spinnerService.show();

    var itemBo = {
      'ItemId': this.RolePermissionModel.UserTypeID
    };
    this.lookupservice.GetLookupsList('Role', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.BranchRoleList = data.LookupItems;
      this.spinnerService.hide();
    });

  };

}

